import API from "@/lib/httpModule";
import { setCookie, getCookie } from "cookies-next";

export async function manifest() {
	try {
		const response = await API.get("/manifest");
		return response.data;
	} catch (err) {
		return false;
	}
}

export async function getUserInfo() {
	try {
		const response = await API.get("/user");
		return response.data;
	} catch (err) {
		return false;
	}
}

export async function updateUserInfo(payload) {
	try {
		const response = await API.put("/user", payload);
		return response.data;
	} catch (err) {
		return false;
	}
}

/**
 * Renew access token
 * @param {object} data -
 * @returns
 */
export async function renewAccessToken() {
	let refreshToken = getCookie("REFRESH_TOKEN");
	if (!refreshToken) {
		return false;
	}
	return API.post_origin(`/auth/retrieve-token`, {
		refresh_token: refreshToken,
	})
		.then(async (rs) => {
			let newAccessToken = rs.data?.data?.token;
			if (newAccessToken) {
				setCookie("ACCESS_TOKEN", newAccessToken);
			}
			let newRefreshToken = rs.data?.data?.refresh_token;
			if (newRefreshToken) {
				setCookie("REFRESH_TOKEN", newRefreshToken);
			}

			return newAccessToken;
		})
		.catch((err) => {
			return false;
		});
}

/**
 * @param {object} data - user info
 * @returns
 */
export async function signUp(data) {
	return API.post("/user/register", data)
		.then(async (res) => {
			const response = res.data;
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Call API /login. If login successfully, Store access token, refresh token and session ID
 * to the local storage. Then store user information, companies list where user belong to
 * and the company that user is active on.
 * @param {object} data - { email, password }
 * @returns
 */
export async function signIn(data) {
	return API.post_origin("/auth/login", data)
		.then(async (res) => {
			const response = res.data;
			return { success: true, data: response };
		})
		.catch((errRes) => {
			let errors = "";
			if (errRes && errRes.errormsg) {
				errors = errRes.errormsg[0];
			}
			return {
				success: false,
				errors: errors,
				data: {},
			};
		});
}

export function signOut() {
	return API.delete("/logout")
		.then((result) => {
			//Clear local storage
			localStorage.removeItem("USER_INFO");
			localStorage.removeItem("ACCESS_TOKEN");
			localStorage.removeItem("REFRESH_TOKEN");

			//Clear redux data
		})
		.catch((err) => {
			return err;
		});
}

// In case ACCESS_TOKEN and REFRESH_TOKEN expired same time.
export function forceSignOut() {
	//Clear local storage
	localStorage.removeItem("USER_INFO");
	localStorage.removeItem("ACCESS_TOKEN");
	localStorage.removeItem("REFRESH_TOKEN");

	//Clear redux data

	return true;
}

/**
 * upload image for service item
 * @param {string} id - id of service item
 * @param {Object} photo - file of image
 * @param {string} model - UPLOAD_MODEL type to upload
 * @param {string} type - type of UPLOAD_IMAGE_TYPE, default 'main'
 * @returns - status success and code is 200
 */
export async function uploadImage(id, photo, model, type = "main") {
	try {
		let formData = new FormData();
		formData.append("file", photo);

		let url = `/upload/image/${model}/${id}/${type}`;
		let response = await API.post(url, formData, {
			"Content-Type": "multipart/form-data",
		});
		if (response && response.status === 200) {
			return {
				success: true,
				data: response.data,
				url: response.data.url,
				image: response.data.image,
			};
		}
	} catch (e) {
		return {
			success: false,
			error: e,
		};
	}
}

/**
 * request OTP reset password
 * @param {Object} data - { email: "", phone: "", method: "" }
 * @returns - status success and code is 200
 */
export async function requestOTPResetPassword(data) {
	try {
		const response = await API.post(`/user/forgot-password`, data);
		return {
			success: true,
			data: response.data,
		};
	} catch (err) {
		return {
			success: false,
			error: err,
		};
	}
}

/**
 * verify OTP reset password
 * @param {Object} data - { email: "", phone: "", otp: "", method: "" }
 * @returns - status success and code is 200
 */
export async function verifyOTPResetPassword(data) {
	try {
		const response = await API.post(`/user/validate-reset-password`, data);
		return {
			success: true,
			data: response.data,
		};
	} catch (err) {
		return {
			success: false,
			error: err,
		};
	}
}

/**
 * submit new password
 * @param {Object} data - { email: "", phone: "", otp: "", method: "", password: "" }
 * @returns - status success and code is 200
 */
export async function resetNewPassword(data) {
	try {
		const response = await API.post(`/user/reset-password`, data);
		return {
			success: true,
			data: response.data,
		};
	} catch (err) {
		return {
			success: false,
			error: err,
		};
	}
}

/**
 * submit new password
 * @param {Object} data - { old_password: "", new_password: "" }
 * @returns - status success and code is 200
 */
export async function changeUserPassword(data) {
	try {
		const response = await API.put(`/user/password`, data);
		return {
			success: true,
			data: response.data,
		};
	} catch (err) {
		return {
			success: false,
			error: err,
		};
	}
}

/**
 * submit new password
 * @param {Object} data - { email: "", code: "", method: "", password: "" }
 * @returns - status success and code is 200
 */
export async function activeUserProfile(data) {
	try {
		const response = await API.put(`/user/active`, data);
		return {
			success: true,
			data: response.data,
		};
	} catch (err) {
		return {
			success: false,
			error: err,
		};
	}
}

/**
 * send otp verify phone
 * @returns - status success and code is 200
 */
export async function sendOTPVerifyPhone(payload) {
	try {
		const response = await API.put(`/user/send-verify-phone`, payload);
		return {
			success: true,
			data: response,
		};
	} catch (err) {
		return {
			success: false,
			error: err,
		};
	}
}

/**
 * send otp verify mail
 * @returns - status success and code is 200
 */
export async function sendOTPVerifyEmail(payload) {
	try {
		const response = await API.put(`/user/send-verify-email`, payload);
		return {
			success: true,
			data: response,
		};
	} catch (err) {
		return {
			success: false,
			error: err,
		};
	}
}

export async function activateUserPassword(payload) {
	try {
		const response = await API.put("/user/active/password", payload);
		return response.data;
	} catch (err) {
		return false;
	}
}
